import { render, staticRenderFns } from "./Inspector.vue?vue&type=template&id=02edd85f&lang=pug&"
import script from "./Inspector.vue?vue&type=script&lang=js&"
export * from "./Inspector.vue?vue&type=script&lang=js&"
import style0 from "./Inspector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02edd85f')) {
      api.createRecord('02edd85f', component.options)
    } else {
      api.reload('02edd85f', component.options)
    }
    module.hot.accept("./Inspector.vue?vue&type=template&id=02edd85f&lang=pug&", function () {
      api.rerender('02edd85f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/Inspector.vue"
export default component.exports